export function getFileExtensionFromUrl(url: string): string {
  const knownTypes: Record<string, string> = {
    '/gifs/': 'gif',
    '/images/': 'png',
  };

  for (const [prefix, ext] of Object.entries(knownTypes)) {
    if (url.includes(prefix)) return ext;
  }

  const extensionMatch = url.match(/\.([a-z0-9]+)(?:[?#]|$)/i);
  return extensionMatch ? extensionMatch[1] : 'png';
}
